import sortBy from 'lodash.sortby';

import { apiNames, get, fetchQuery } from '@general/api/shared';

export const url = 'states';
const fetchRequest = () => get(apiNames.MEMBERSHIP, url);

// [{name: "Boeotia Regional Unit", code: "3", country: "GR"}, ...]
export const statesToOptions = data => {
    const states = data.map(c => ({ label: c.name, value: c.code, country: c.country }));

    return sortBy(states, 'label');
};

export const getStates = ({ transformData }) => fetchQuery({ fetchRequest, transformData });
